module.exports = __webpack_public_path__ + "static/feature-network-mid-74947379d8af668d81986580679a3d56.png";